import {makeAutoObservable} from "mobx";
import {AuditLogsResponse} from "../../entity/resource/audit-logs-response";
import {AuditLogsAgent} from "../agent/audit-logs-agent";

export default class AuditLogsStore {
  auditLogsAgent: AuditLogsAgent;

  constructor(auditLogsAgent: AuditLogsAgent) {
    makeAutoObservable(this);
    this.auditLogsAgent = auditLogsAgent;
  }

  getAuditLogs = async (organizationId: string, batchId: string): Promise<AuditLogsResponse[] | string> => {
    try {
      return await this.auditLogsAgent.getAuditLogs(organizationId, batchId);
    } catch (error: any) {
      console.error('Error occurred while get title logs. Please try again in while !!', error);
      return 'Error occurred while get title logs. Please try again in while !!';
    }
  }
}
